import type { JobApprovalDto } from "@/lib/job-approvals";
import { ApprovalCard } from "./approval-card";

export interface ApprovalListProps {
  approvals: JobApprovalDto[];
  onDecide: (
    approvalId: number,
    decision: "Approve" | "Reject",
    comment: string | undefined,
    rowVersionBase64: string,
  ) => void;
  onAddComment: (approvalId: number, text: string) => void;
}

export function ApprovalList({ approvals, onDecide, onAddComment }: ApprovalListProps) {
  if (approvals.length === 0) {
    return (
      <p className="text-sm text-muted-foreground" data-testid="approval-list-empty">
        No approvals
      </p>
    );
  }

  return (
    <div className="space-y-3" data-testid="approval-list">
      {approvals.map((approval) => (
        <ApprovalCard
          key={approval.jobApprovalId}
          approval={approval}
          onDecide={onDecide}
          onAddComment={onAddComment}
        />
      ))}
    </div>
  );
}
